import {
    doc,
    getDoc
  } from "firebase/firestore";
import { db } from "../firebase";

const getUserDetails = async (id) => {
    try {
        const userRef = doc(db, "users", id);
        const userSnap = await getDoc(userRef);
        
        if(userSnap.exists()){
        return userSnap.data();
        }
        else{
        return null;
        }
    } catch (error) {
        if(error.toString().includes("offline")){
            window.alert('Pas de connexion internet')
        }
        else{
            window.alert(error)
        }
    }
};

const getExamDetails = async (id) => {
    try {
        const userRef = doc(db, "exam", id);
        const userSnap = await getDoc(userRef);
        
        if(userSnap.exists()){
        return userSnap.data();
        }
        else{
        return null;
        }
    } catch (error) {
        if(error.toString().includes("offline")){
            window.alert('Pas de connexion internet')
        }
        else{
            window.alert(error)
        }
    }
};

const getStatus = async (id) => {
    try {
        const userRef = doc(db, "submissions", id);
        const userSnap = await getDoc(userRef);
        
        if(userSnap.exists())
            return true;
        else
            return false;
        
    } catch (error) {
        console.log(error);
    }
};

const userController = {
    getUserDetails,
    getStatus,
    getExamDetails
}
  
export default userController